// @flow

import React from 'react';
import Tile from '../tile';
import OptionBundle from '../../../optionBundle';
import StyledTilesColumn from '../tilesColumn';
import type { Bundle } from '../../../../../../types/pdb';

type Props = {
  blocks: ?Array<Bundle>,
  activeBlock: ?number,
  setBlock: Function,
};

const TilesBundleColumn = ({ blocks, activeBlock, setBlock }: Props) => {
  const blockCount = blocks ? blocks.length : 0;

  return (
    <StyledTilesColumn>
      {blocks && blocks.map(({
        id, name, price, description, image, most_chosen, extras,
      }) => (
        <Tile
          key={id}
          active={(activeBlock && activeBlock === id) || false}
          onClick={() => setBlock(id)}
          blocksPerRow={1}
          blockCount={blockCount}
          mostChosen={most_chosen}
        >
          <OptionBundle
            id={id}
            title={name}
            price={parseFloat(price)}
            active={(activeBlock && activeBlock === id) || false}
            description={description || ''}
            imageUrl={image && image.url && image.url.replace('__width__', '300')}
            extras={extras && extras.map(extra => ({
              icon: 'check',
              usp: extra.name,
              url: null,
            }))}
          />
        </Tile>
      ))}
    </StyledTilesColumn>
  );
};

export default TilesBundleColumn;
